import type { State } from 'src/models';

export const getToken = (state: State): string | undefined => state.user.token;
export const getIsAuthorized = (state: State): boolean => !!state.user.token;
